<template>
  <div class="home">
    <div class="page-navbar">
      <div class="page-navbar-wrapper">
        <ul>
          <li
            :data-menuanchor="navbar.anchor"
            :key="i"
            @click="moveToSection(i)"
            v-for="(navbar, i) in this.home.text.pageNavbar"
          >
            <span>{{ navbar.name }}</span>
          </li>
        </ul>
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>
    </div>
    <full-page :options="this.home.options" id="fullpage" ref="fullpage">
      <div
        class="container-site-padding home-header section fp-auto-height-responsive"
        data-anchor="home"
      >
        <div class="section-container">
          <div class="car">
            <div class="car-wrapper">
              <img
                alt="Mitsubishi"
                data-aos="slide-in-blurred-left"
                data-aos-duration="1000"
                src="../assets/images/home/header-car_ec-phev.png"
              />
              <img
                alt="glow"
                data-aos="fade-in"
                data-aos-duration="1000"
                data-aos-delay="1000"
                class="glow"
                src="../assets/images/home/header-car-glow.png"
              />
              <div
                :data-aos-delay="i * 150 + 1000"
                :key="link.name"
                class="dots"
                data-aos="bounceIn"
                data-aos-duration="300"
                v-for="(link, i) in this.home.text.carHeaderLinks"
              >
                <router-link
                  :class="link.position"
                  :to="link.href"
                  v-if="i !== 5"
                  >{{ link.name }}
                </router-link>
                <p
                  :class="link.position"
                  @click="carSlider.showDialog = true"
                  v-else
                >
                  360<sup>o</sup>
                </p>
                <router-link :to="link.href" tag="span" v-if="i !== 5">
                  <v-progress-circular
                    indeterminate
                    rotate="180"
                    size="40"
                    value="55"
                    width="1"
                  ></v-progress-circular>
                  <v-progress-circular
                    indeterminate
                    rotate="222"
                    size="50"
                    value="20"
                    width="1"
                  ></v-progress-circular>
                  <v-progress-circular
                    indeterminate
                    rotate="-270"
                    size="65"
                    value="10"
                    width="1"
                  ></v-progress-circular>
                  <v-progress-circular
                    :value="0"
                    indeterminate
                    rotate="-90"
                    size="85"
                    width="1"
                  ></v-progress-circular>
                </router-link>
                <span @click="carSlider.showDialog = true" v-else>
                  <v-progress-circular
                    indeterminate
                    rotate="180"
                    size="40"
                    value="55"
                    width="1"
                  ></v-progress-circular>
                  <v-progress-circular
                    indeterminate
                    rotate="222"
                    size="50"
                    value="20"
                    width="1"
                  ></v-progress-circular>
                  <v-progress-circular
                    indeterminate
                    rotate="-270"
                    size="65"
                    value="10"
                    width="1"
                  ></v-progress-circular>
                  <v-progress-circular
                    :value="0"
                    indeterminate
                    rotate="-90"
                    size="85"
                    width="1"
                  ></v-progress-circular>
                </span>
              </div>
              <div class="dots-information">
                <p
                  data-aos="text-focus-in"
                  data-aos-delay="1000"
                  data-aos-duration="1000"
                >
                  Najedź na poszczególne elementy samochodu powyżej by
                  dowiedzieć się więcej.
                </p>
              </div>
            </div>
          </div>
          <div class="header-text text-uppercase">
            <h1 style="display: none">Mitsubishi</h1>
            <p
              class="plug-in"
              data-aos="text-focus-in"
              data-aos-duration="1000"
            >
              Elektryczny
            </p>
            <p
              class="vehicle"
              data-aos="text-focus-in"
              data-aos-delay="150"
              data-aos-duration="1000"
            >
              I Hybrydowy
            </p>

            <div>
            <v-btn
              :class="'mmc-red background'"
              v-ripple="{ class: 'ripple-red' }"
              href="https://www.mitsubishi.pl/glowna-jazda-probna"
              target="_blank"
              data-aos="zoom-in"
              data-aos-duration="500"
            >
              Kontakt online
            </v-btn>
          </div>
          </div>
          <div
            class="scroll-text"
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="500"
          >
            <div class="scroll-downs">
              <div class="mousey">
                <div class="scroller"></div>
              </div>
            </div>
            <p>
              Przewiń w dół by sprawdzić co jeszcze oferuje Eclipse Cross PHEV
            </p>
          </div>
        </div>
      </div>
      <div
        class="drive-control section fp-auto-height-responsive"
        data-anchor="drive-control"
      >
        <div class="section-container">
          <div class="box">
            <router-link
              class="uppercase link"
              data-aos="tracking-in-expand"
              data-aos-duration="500"
              to="/interior"
              >{{ this.home.text.interior }}
            </router-link>
            <div class="background"></div>
          </div>
          <div class="box">
            <p
              @click="carSlider.showDialog = true"
              class="uppercase link"
              data-aos="tracking-in-expand"
              data-aos-duration="500"
            >
              {{ this.home.text.section360 }}<sup>o</sup>
            </p>
            <div class="background"></div>
          </div>
        </div>
        <div class="car-info-box">
          <div class="box-image">
            <img
              alt="Car"
              data-aos="slide-right"
              data-aos-duration="500"
              src="../assets/images/home/car-electric-first_ec-phev.png"
            />
          </div>
          <div class="box-description text-right">
            <h5
              class="uppercase header-sub"
              data-aos="fade-left"
              data-aos-duration="500"
            >
              {{ this.home.text.firstBoxSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="fade-left"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.home.text.firstBoxHeader }}
            </h2>
            <p
              class="description"
              data-aos="fade-left"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              Doświadcz nowego poziomu radości z jazdy, jaki oferuje nowy
              hybrydowy SUV coupe typu Plug-in. Współpracujące ze sobą dwa
              silniki elektryczne (na przedniej i tylnej osi) oraz silnik
              benzynowy zapewniają optymalne osiągi w danej sytuacji. Jeżdżąc
              PHEV dbasz o środowisko w którym żyjesz. Niska emisja CO<sub
                >2</sub
              >
              i tryb jazdy zeroemisyjnej w mieście to ulice wielkich miast wolne
              od smogu i hałasu. To lepsza perspektywa na przyszłość i poprawa
              warunków życia dla kolejnych pokoleń. To możliwość realnego wpływu
              na stan naszej jedynej planety.
            </p>
            <v-btn
              :class="'mmc-blue text'"
              data-aos="fade-left"
              data-aos-delay="450"
              data-aos-duration="500"
              href="car-drive"
              v-ripple="{ class: 'ripple-blue' }"
              >{{ this.home.text.firstBoxButton }}
            </v-btn>
          </div>
        </div>
      </div>
      <div
        class="car-drive section fp-auto-height-responsive"
        data-anchor="car-drive"
      >
        <div class="car-info-box">
          <div class="box-description text-left">
            <h5
              class="uppercase header-sub"
              data-aos="fade-right"
              data-aos-duration="500"
            >
              {{ this.home.text.secondBoxSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="fade-right"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.home.text.secondBoxHeader }}
            </h2>
            <p
              class="description"
              data-aos="fade-right"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.home.text.secondBoxDescription }}
            </p>
            <v-btn
              :class="'mmc-blue text'"
              data-aos="fade-right"
              data-aos-delay="450"
              data-aos-duration="500"
              href="drive-control"
              v-ripple="{ class: 'ripple-blue' }"
              >{{ this.home.text.secondBoxButton }}
            </v-btn>
          </div>
          <div class="box-image text-right">
            <img
              alt="Car"
              data-aos="slide-left"
              data-aos-duration="500"
              src="../assets/images/home/car-electric-second_ec-phev.jpg"
            />
          </div>
        </div>
        <div class="section-container">
          <div class="wrapper">
            <router-link
              class="uppercase link"
              data-aos="tracking-in-expand"
              data-aos-duration="500"
              to="/safety"
              >{{ this.home.text.safety }}
            </router-link>
            <div class="background"></div>
          </div>
        </div>
      </div>
      <div
        class="container-site-padding explore section fp-auto-height-responsive"
        data-anchor="explore"
      >
        <div class="section-container">
          <div class="wrapper text-center">
            <div class="explore-text">
              <h5
                class="uppercase header-sub"
                data-aos="fade-down"
                data-aos-duration="500"
              >
                {{ this.home.text.exploreSubHeader }}
              </h5>
              <h2
                class="uppercase header"
                data-aos="zoom-in"
                data-aos-delay="150"
                data-aos-duration="500"
              >
                {{ this.home.text.exploreHeader }}
              </h2>
              <p
                class="description"
                data-aos="zoom-in"
                data-aos-delay="300"
                data-aos-duration="500"
              >
                {{ this.home.text.exploreDescription }}
              </p>
              <v-btn
                :class="'mmc-blue text'"
                data-aos="bounceIn"
                data-aos-delay="450"
                data-aos-duration="500"
                href="color-and-accessories"
                v-ripple="{ class: 'ripple-blue' }"
                >{{ this.home.text.exploreButton }}
              </v-btn>
            </div>
          </div>
          <div class="car-image">
            <img
              alt="Car"
              data-aos="slide-in-blurred-bottom"
              data-aos-duration="500"
              src="../assets/images/home/car-safety-bottom_ec-phev.png"
            />
          </div>
        </div>
      </div>
      <div
        class="container-site-padding versions section fp-auto-height-responsive"
        data-anchor="versions"
      >
        <div class="section-container">
          <h5
            class="uppercase header-sub"
            data-aos="fade-down"
            data-aos-duration="500"
          >
            {{ this.home.text.sliderHeader }}
          </h5>
          <swiper
            :options="home.mainSlider"
            @slideChange="updatePaginationIndex"
            class="swiper slider-flex"
            ref="mainSlider"
          >
            <swiper-slide
              :key="car.name"
              class="slider-item"
              v-for="car in this.home.text.slider"
            >
              <div
                class="slider-description gallery"
                data-selector=".swiper-slide:not(.swiper-slide-duplicate)"
              >
                <h3
                  class="uppercase header"
                  data-aos="slide-right"
                  data-aos-duration="500"
                >
                  {{ car.name }}
                </h3>
                <swiper
                  :options="home.carSlider"
                  @resize="carOnResize"
                  class="swiper"
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  ref="carSlider"
                >
                  <swiper-slide
                    :data-src="require(`@/assets/images/home/${image}`)"
                    :key="i"
                    v-for="(image, i) in car.images"
                  >
                    <img
                      :src="require(`@/assets/images/home/${image}`)"
                      alt=""
                    />
                  </swiper-slide>
                </swiper>
                <div class="specs">
                  <p class="text-uppercase">
                    Najważniejsze elementy wyposażenia wersji {{ car.name }}:
                  </p>
                  <ul
                    :key="index"
                    class="spec-box"
                    v-for="(spec, index) of car.specs"
                  >
                    <li :key="i" v-for="(specDesc, i) of spec">
                      {{ specDesc }}
                    </li>
                  </ul>
                </div>
                <i @click="nextActiveCar" class="fas fa-angle-right"></i>
              </div>
              <div class="slider-interior gallery" data-selector="div">
                <div
                  :data-aos-delay="i * 150"
                  :data-src="require('@/assets/images/home/' + interior)"
                  :key="i + interior"
                  :style="{
                    backgroundImage:
                      'url(' + require('@/assets/images/home/' + interior) + ')'
                  }"
                  class="interior"
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  v-for="(interior, i) in car.interior"
                >
                  <i class="fas fa-image"></i>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="under-slider">
            <ul
              class="slider-pagination"
              data-aos="zoom-in"
              data-aos-duration="500"
            >
              <li
                :class="i === home.mainSliderActiveIndex ? 'current-slide' : ''"
                :key="page.name"
                @click="goToPage(i)"
                class="text-uppercase"
                v-for="(page, i) in this.home.text.slider"
              >
                {{ page.name }}
              </li>
            </ul>
            <div class="buttons">
              <!--<v-btn
                :class="'mmc-red background text-center'"
                data-aos="bounceIn"
                data-aos-duration="500"
                href="https://www.mitsubishi.pl/storage/file/core_files/2021/8/17/7a097665ada292c027850681cb59209e/katalog_mitsubishi_eclipse_cross_phev_my21_prev-1-17082021.pdf"
                v-ripple="{ class: 'ripple-red' }"
                >{{ this.home.text.specButton }}
              </v-btn>-->
            </div>
          </div>
        </div>
      </div>
      <div
        class="gallery-slider section fp-auto-height-responsive"
        data-anchor="equipment"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.home.text.equipmentHeaderSub }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.home.text.equipmentHeader }}
            </h2>
          </div>
          <div class="gallery-nav">
            <i class="fas fa-angle-left" @click="prevGallerySlide"></i>
            <i class="fas fa-angle-right" @click="nextGallerySlide"></i>
          </div>
          <swiper
            :options="home.gallerySlider"
            class="swiper slider-flex gallery"
            data-selector=".swiper-slide:not(.swiper-slide-duplicate)"
            ref="gallerySlider"
          >
            <swiper-slide
              class="slider-item"
              :data-src="require('@/assets/images/color/' + gallery.image)"
              :key="index"
              v-for="(gallery, index) in this.home.text.gallerySlider"
            >
              <div class="text">
                <h5
                  class="uppercase header-sub second"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                  data-aos-duration="500"
                >
                  {{ gallery.header }}
                </h5>
                <p
                  class="description"
                  data-aos="zoom-in"
                  data-aos-delay="450"
                  data-aos-duration="500"
                >
                  {{ gallery.desc }}
                </p>
              </div>
              <div
                class="background"
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/color/' + gallery.image) +
                    ')'
                }"
              >
                <i class="fas fa-image"></i>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div
        class="history section fp-auto-height-responsive"
        data-anchor="history"
      >
        <div class="section-container">
          <div class="wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.home.text.historySubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="slide-right"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.home.text.historyHeader }}
            </h2>
            <p
              class="description"
              data-aos="slide-right"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.home.text.historyDescription }}
            </p>
            <v-btn
              :class="'mmc-blue'"
              data-aos="bounceIn"
              data-aos-delay="450"
              data-aos-duration="500"
              href="timeline"
              v-ripple="{ class: 'ripple-blue' }"
              >{{ this.home.text.historyButton }}
            </v-btn>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </full-page>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FullPage from "vue-fullpage.js/src/FullPage.vue";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    FullPage,
    Footer
  },
  computed: {
    ...mapGetters({
      home: "home",
      header: "header",
      carSlider: "carSlider"
    })
  },
  methods: {
    ...mapMutations({
      changeSliderPage: "changeSliderPage"
    }),
    nextActiveCar() {
      this.$refs.carSlider[
        this.$refs.mainSlider.swiper.realIndex
      ].swiper.slideNext();
    },
    carOnResize() {
      setTimeout(() => {
        this.$refs.carSlider[
          this.$refs.mainSlider.swiper.realIndex
        ].swiper.update();
        this.$refs.mainSlider.swiper.update();
      }, 50);
    },
    goToPage(value) {
      this.$refs.mainSlider.swiper.slideToLoop(value);
      this.updatePaginationIndex();
    },
    updatePaginationIndex() {
      this.changeSliderPage(this.$refs.mainSlider.swiper.realIndex);
    },
    updateHomeHeaderSize() {
      this.header.homeHeaderYSize = document.querySelector(
        ".home-header"
      ).offsetHeight;
    },
    moveToSection(index) {
      this.$refs.fullpage.api.moveTo(index + 1);
    },
    prevGallerySlide() {
      this.$refs.gallerySlider.swiper.slidePrev();
      this.updateCarSliderIndex();
    },
    nextGallerySlide() {
      this.$refs.gallerySlider.swiper.slideNext();
    }
  },
  mounted() {
    const galleries = document.getElementsByClassName("gallery");
    const body = document.querySelector("body");

      Array.prototype.forEach.call(galleries, e => {
        window.lightGallery(e, {
          selector: e.getAttribute("data-selector"),
          download: false,
          autoplay: false,
          videoMaxWidth: "1920px"
        });
      });

    body.classList.add("no-overflow");

    this.updateHomeHeaderSize();
    window.addEventListener("resize", this.updateHomeHeaderSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHomeHeaderSize);
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/mixins";
@import "src/styles/page-navbar";

@mixin background-image($image) {
  @include set-position(absolute, 0, 0, 0, 0);
  @include set-background(no-repeat, right center, cover);
  background-image: url($image);
  transition: transform 0.5s ease-in-out;
}

@mixin box-description($color, $left, $right) {
  .box-description {
    padding-left: $left;
    padding-right: $right;

    .header-sub {
      color: $color;
    }
  }
}

.section-container {
  overflow: hidden;
}

.home-header {
  @include set-background(no-repeat, center center, cover);
  background-image: url("../assets/images/home/header-background.jpg");
  min-height: 100vh;

  .section-container {
    @include display-flex(flex, wrap);
    min-height: 100vh;
    padding: calc(2 * var(--page-offset) + 77px) var(--page-offset)
      var(--page-offset);

    @media screen and (max-width: $screen-sm) {
      align-content: center;
    }

    .car {
      @include size-flex(60%);
      align-self: center;

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
        margin-bottom: 4rem;
      }

      .car-wrapper {
        @include z-index(relative, 1);
        float: right;
        right: -3.5rem;

        @media screen and (max-width: $screen-sm) {
          right: 0;
        }

        &::after {
          content: "";
          clear: both;
          display: table;
        }

        .glow {
          @include set-position(absolute, 50%, 50%, auto, auto);
          @include set-max-size(100%, 100%);
          transform: translate(50%, -50%);
          z-index: 0;
        }
      }

      .dots-information {
        @include set-position(
          absolute,
          auto,
          auto,
          calc(-1 * var(--page-offset) / 2),
          0
        );
        user-select: none;
        width: 50%;

        @media screen and (max-width: $screen-sm) {
          width: 100%;
          bottom: -2rem;
        }

        p {
          @include font-size-color(0.8rem, $white);
          margin: 0;
        }
      }

      img {
        @include set-max-size(100%, 100%);
        @include z-index(relative, 1);
      }

      .dots {
        position: absolute;
        cursor: pointer;
        z-index: 9;

        $dot-top: 16%, 22%, 20%, 77%, 44%, 6%, 30%, 16%;
        $dot-left: 9%, 71%, 35%, 47%, 90%, 20%, 80%, 56%;

        @for $i from 1 through length($dot-top) {
          &:nth-of-type(#{$i}) {
            top: nth($dot-top, $i);
            left: nth($dot-left, $i);
          }
        }

        &:hover {
          z-index: 10;

          a,
          p {
            opacity: 1;
            visibility: visible;
          }

          > span {
            div {
              opacity: 1;
              visibility: visible;
            }
          }
        }

        a,
        p {
          @include set-position(absolute, -3.5rem, 2rem, auto, auto);
          @include font-size-weight(1.25rem, 900);
          text-decoration: none;
          color: $white;
          text-transform: uppercase;
          margin: 0;
          white-space: nowrap;
          text-shadow: 0 0 5px $mmc-blue;
          opacity: 0;
          z-index: 1;
          visibility: hidden;
          transition: opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1);

          @media screen and (max-width: $screen-es) {
            font-size: 1rem;
            right: 1rem;
          }

          &::after {
            @include set-position(absolute, auto, 0, -0.5rem, auto);
            @include set-size(80%, 1px);
            content: "";
            background-color: $mmc-blue;
            box-shadow: 0 0 5px 1px $mmc-blue;
          }

          &::before {
            @include set-position(absolute, auto, -2rem, -0.5rem, auto);
            @include set-size(2rem, 1px);
            content: "";
            transform: rotate(45deg);
            transform-origin: 0;
            background-color: $mmc-blue;
            box-shadow: 0 0 5px 1px $mmc-blue;

            @media screen and (max-width: $screen-es) {
              transform: rotate(70deg);
            }
          }

          &.right {
            right: auto;
            left: 2rem;

            @media screen and (max-width: $screen-es) {
              left: 1rem;
            }

            &::after {
              right: auto;
              left: 0;
            }

            &::before {
              right: auto;
              left: 0;
              transform: rotate(135deg);

              @media screen and (max-width: $screen-es) {
                transform: rotate(110deg);
              }
            }
          }
        }

        > span {
          @include set-size(0.7rem, 0.7rem);
          @include z-index(relative, 0);
          display: block;
          border-radius: 50%;
          border: 1px solid #2bf7ff;
          background-color: $white;
          box-shadow: 0 0 10px 1px rgba(#00d8ff, 0.5);

          &::after {
            @include set-position(absolute, 50%, 50%, auto, auto);
            @include set-size(1.7rem, 1.7rem);
            transform: translate(50%, -50%);
            content: "";
            border-radius: 50%;
            border: 1px solid #00d8ff;
          }

          &::before {
            @include set-position(absolute, 50%, 50%, auto, auto);
            @include set-size(100%, 100%);
            transform: translate(50%, -50%);
            content: "";
            border-radius: 50%;
            box-shadow: 0 0 10px 1px $mmc-blue;
            animation: box-shadow-circle 1s infinite ease-in-out;
          }

          @-webkit-keyframes box-shadow-circle {
            0% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
            50% {
              box-shadow: 0 0 15px 8px $mmc-blue;
            }
            100% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
          }
          @-moz-keyframes box-shadow-circle {
            0% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
            50% {
              box-shadow: 0 0 15px 8px $mmc-blue;
            }
            100% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
          }
          @-o-keyframes box-shadow-circle {
            0% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
            50% {
              box-shadow: 0 0 15px 8px $mmc-blue;
            }
            100% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
          }
          @keyframes box-shadow-circle {
            0% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
            50% {
              box-shadow: 0 0 15px 8px $mmc-blue;
            }
            100% {
              box-shadow: 0 0 15px 1px $mmc-blue;
            }
          }

          div {
            @include set-position(absolute, 50%, auto, auto, 50%);
            transform: translate(-50%, -50%);
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1);
          }
        }
      }
    }

    .header-text {
      @include size-flex(40%);
      align-self: center;
      text-align: right;
      user-select: none;

      @media screen and (max-width: $screen-md) {
        align-self: center;
        margin-bottom: 10rem;
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
        margin-bottom: 0;
      }

      p {
        font-weight: 900;
        margin: 0;
        line-height: 1;

        &.plug-in {
          color: $mmc-blue;
          font-size: 4.4vw;

          @media screen and (max-width: 1800px) {
            font-size: 4vw;
          }

          @media screen and (max-width: $screen-sm) {
            font-size: 10vw;
          }

          @media screen and (max-width: $screen-xs) {
            font-size: 8vw;
          }

          span {
            color: $mmc-blue;
          }
        }

        &.vehicle {
          font-size: 4.4vw;
          margin-bottom: var(--page-offset);

          @media screen and (max-width: 1800px) {
            font-size: 4vw;
          }

          @media screen and (max-width: $screen-sm) {
            font-size: 10vw;
          }

          @media screen and (max-width: $screen-xs) {
            font-size: 8vw;
          }
        }
      }

      .mmc-blue {
        .v-btn__content {
          position: static !important;
        }

        @media screen and (max-width: $screen-lg) {
          width: 75% !important;
          font-size: 0.8rem !important;

          i {
            margin-right: 0.6rem;
          }
        }

        @media screen and (max-width: $screen-sm) {
          width: auto !important;
          font-size: 1rem !important;
        }

        @media screen and (max-width: $screen-es) {
          font-size: 0.8rem !important;
        }
      }
    }

    .scroll-text {
      @include set-position(
        absolute,
        auto,
        calc(2 * var(--page-offset)),
        calc(var(--page-offset) / 2),
        auto
      );
      text-align: right;
      width: 15rem;

      @media screen and (max-width: $screen-sm) {
        position: relative;
        width: 100%;
        bottom: 0;
        right: 0;
        margin-top: 2rem;
      }

      .scroll-downs {
        display: inline-block;
      }

      p {
        @include font-size-color(0.8rem, $white);
        margin: 1rem 0 0;
      }
    }
  }
}

.drive-control {
  @include display-flex(flex, wrap);
  min-height: 100vh;

  .section-container {
    @include size-flex(100%);
    @include display-flex(flex, wrap);
    padding: 0 var(--page-offset) calc(var(--page-offset) / 2);
    min-height: 50vh;
    max-height: 50vh;

    @media screen and (max-width: $screen-sm) {
      min-height: 35vh;
    }

    .box {
      @include display-flex(flex, wrap);
      @include size-flex(50%);
      padding: var(--page-offset);
      position: relative;
      overflow: hidden;
      align-content: flex-end;

      @media screen and (max-width: $screen-es) {
        @include size-flex(100%);
      }

      &:first-of-type {
        .background {
          background-image: url("../assets/images/home/360-interior_ec-phev.jpg");
          background-position: left center;
        }
      }

      &:last-of-type {
        .background {
          background-image: url("../assets/images/home/360-car_ec-phev.jpg");
          background-position: left center;
        }
      }

      &:hover {
        .background {
          transform: scale(1.05);
        }
      }

      .link {
        @include z-index(relative, 1);
        margin-top: 0;
        cursor: pointer;
      }

      .background {
        @include background-image("");
      }
    }
  }

  .car-info-box {
    @include box-description($mmc-blue, var(--page-offset), 0);
    padding-right: calc(var(--page-offset) * 2);

    .box-image {
      &::after {
        @include set-position(absolute, 0, auto, 0, 0);
        content: "";
        background-color: $mmc-gray-light;
        width: 85%;
      }

      img {
        padding-top: calc(var(--page-offset) / 2);
        vertical-align: bottom;

        @media screen and (max-height: $screen-height-md) {
          max-height: 25rem;
        }

        @media screen and (max-width: $screen-sm) {
          max-height: none;
        }
      }
    }

    .box-description {
      align-self: center;
    }
  }
}

.car-drive {
  @include display-flex(flex, wrap);
  min-height: 100vh;

  .section-container {
    @include display-flex(flex, wrap);
    @include size-flex(100%);
    padding: var(--page-offset) var(--page-offset) 0;
    align-self: flex-end;
    min-height: 50vh;
    max-height: 50vh;

    @media screen and (max-width: $screen-sm) {
      min-height: 35vh;
    }

    .wrapper {
      @include display-flex(flex, wrap);
      padding: var(--page-offset);
      position: relative;
      overflow: hidden;
      flex: 1 0 100%;
      align-items: flex-end;

      > *:not(.background) {
        @include z-index(relative, 1);
      }

      .link {
        margin-top: 0;
      }
    }

    &:hover {
      .background {
        transform: scale(1.05);
      }
    }

    .background {
      @include background-image("../assets/images/home/car-safety_ec-phev.jpg");
    }
  }

  .car-info-box {
    @include box-description($mmc-blue, 0, var(--page-offset));
    padding-left: calc(var(--page-offset) * 2);
    align-items: center;
    align-self: center;

    .box-image {
      align-self: center;
    }
  }
}

.car-info-box {
  @include display-flex(flex, wrap);
  align-self: center;

  @media screen and (max-width: $screen-sm) {
    padding-left: var(--page-offset);
    padding-right: var(--page-offset);

    &:first-of-type {
      padding-right: var(--page-offset);
    }

    &:last-of-type {
      padding-left: var(--page-offset);
    }
  }

  .box-image {
    @include size-flex(50%);
    align-self: flex-end;
    position: relative;

    @media screen and (max-width: $screen-sm) {
      @include size-flex(100%);
    }

    img {
      @include z-index(relative, 1);
      max-width: 100%;

      @media screen and (max-height: $screen-height-md) {
        max-height: 25rem;
      }

      @media screen and (max-width: $screen-sm) {
        max-height: none;
      }
    }
  }

  .box-description {
    @include size-flex(50%);

    @media screen and (max-width: $screen-sm) {
      @include size-flex(100%);
      padding: var(--page-offset) 0;
    }

    .header,
    .description {
      color: $black;

      sub {
        color: $black;
      }
    }

    .header-sub {
      margin-top: 1.5rem;
    }

    @media screen and (max-height: $screen-height-lg) {
      .header-sub {
        font-size: 1.3rem;
      }

      .header {
        font-size: 2.15rem;
        margin: 1rem 0;
      }

      .description {
        font-size: 0.8rem !important;
        line-height: 1.2;
        margin-bottom: 1rem !important;
      }
    }

    @media screen and (max-width: $screen-lg) {
      .header-sub {
        font-size: 1.3rem;
      }

      .header {
        font-size: 2.15rem;
        margin: 1rem 0;
      }

      .description {
        font-size: 0.8rem !important;
        line-height: 1.2;
        margin-bottom: 1rem !important;
      }
    }

    @media screen and (max-width: $screen-sm) {
      .header-sub {
        font-size: 1.2rem;
      }

      .header {
        font-size: 1.8rem;
      }

      .description {
        font-size: 1rem !important;
      }
    }

    .v-btn {
      @media screen and (max-width: $screen-xs) {
        text-align: center !important;
      }
    }
  }
}

.explore {
  @include display-flex(flex, wrap);
  position: relative;
  overflow: hidden;
  min-height: 100vh;

  &::after {
    @include set-position(absolute, auto, 0, calc(-1 * var(--page-offset)), 0);
    content: "";
    height: 22rem;
    z-index: 0;
    background-image: linear-gradient($white, rgba($black, 0.07));
  }

  .section-container {
    @include margin-padding(
      0 0 var(--page-offset),
      0 var(--page-offset) var(--page-offset)
    );
    @include set-background(no-repeat, center center, cover);
    @include z-index(relative, 1);
    background-image: url("../assets/images/home/car-safety-road.png");
    overflow: visible;

    .wrapper {
      @include display-flex(flex, wrap);
      @include set-background(repeat, center center, cover);
      background-image: url("../assets/images/home/car-safety-road-bg.png");
      padding: var(--page-offset) (calc(var(--page-offset) / 2)) 22rem;
      height: 100%;
      align-content: center;

      .explore-text {
        @include size-flex(100%);

        .header-sub {
          color: $mmc-blue;
        }
      }
    }

    .car-image {
      @include set-position(
        absolute,
        auto,
        auto,
        calc(-1 * var(--page-offset)),
        50%
      );
      transform: translateX(-50%);
      z-index: 2;
      text-align: center;

      img {
        vertical-align: bottom;
      }
    }

    .v-btn {
      color: $white !important;
    }

    @media screen and (max-height: $screen-height-lg) {
      .header {
        font-size: 2.15rem;
        margin: 1rem 0;
      }

      .description {
        font-size: 0.8rem !important;
        line-height: 1.2;
        margin-bottom: 1rem !important;
      }
    }

    @media screen and (max-width: $screen-lg) {
      .header {
        font-size: 2.15rem;
        margin: 1rem 0;
      }

      .description {
        font-size: 0.8rem !important;
        line-height: 1.2;
        margin-bottom: 1rem !important;
      }
    }

    @media screen and (max-width: $screen-xl) {
      .wrapper {
        padding-bottom: 18rem;
      }

      img {
        max-width: 40rem;
      }
    }

    @media screen and (max-height: $screen-height-lg) {
      img {
        max-height: 28rem;
      }
    }

    @media screen and (max-height: $screen-height-md) {
      img {
        max-height: 23rem;
      }
    }

    @media screen and (max-height: $screen-height-sm) {
      .wrapper {
        padding-bottom: 18rem;
      }

      .header {
        font-size: 1.5rem;
      }

      .description {
        font-size: 1rem !important;
      }

      img {
        max-height: 18rem;
      }
    }

    @media screen and (max-width: $screen-lg) {
      img {
        max-width: 35rem;
      }
    }

    @media screen and (max-width: $screen-sm) {
      .wrapper {
        padding-bottom: 65%;
      }

      .car-image {
        left: 0;
        transform: none;
        width: 100%;
      }

      img {
        max-width: 80%;
      }
    }

    @media screen and (max-width: $screen-es) {
      .v-btn {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
      }
    }
  }
}

.versions {
  @include display-flex(flex, wrap);
  align-content: center;
  overflow: hidden;
  position: relative;
  min-height: 100vh;

  &::after {
    @include set-position(absolute, 50%, auto, auto, 50%);
    @include set-background(no-repeat, center center, contain);
    @include set-size(2257px, 613px);
    max-width: 90vw;
    background-image: url("../assets/images/home/ec-phev-text.png");
    content: "";
    font-weight: 900;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  .section-container {
    @include z-index(relative, 1);
    padding: var(--page-offset);
  }

  .header-sub {
    color: $mmc-blue;
  }

  .header {
    color: $slider-header;
    margin: 1rem 0 0.5rem;
  }

  .description {
    color: $slider-description;
  }

  .specs {
    @include display-flex(flex, wrap);
    border: 2px solid #c9c9c9;
    padding: 1rem;

    @media screen and (max-width: $screen-lg) {
      padding: 0.5rem;
    }

    @media screen and (max-width: $screen-es) {
      margin-bottom: 1rem;
    }

    p {
      @include size-flex(100%);
      @include font-size-weight(1rem, 900);
      margin: 0;
      color: $slider-description;

      @media screen and (max-height: $screen-height-mlg) {
        font-size: 0.8rem;
      }

      @media screen and (max-width: $screen-sm) {
        font-size: 1rem;
        line-height: 1;
      }
    }

    .spec-box {
      @include margin-padding(0, 1rem 0 0);
      @include size-flex(25%);
      list-style: none;

      @media screen and (max-width: $screen-lg) {
        @include size-flex(50%);
      }

      @media screen and (max-width: $screen-md) {
        @include size-flex(100%);
      }

      &:last-of-type {
        padding-right: 0;
      }

      li {
        @include font-size-color(0.8rem, #686767);
        padding: 0 1rem 0 0.5rem;
        position: relative;
        line-height: 1.2;

        @media screen and (max-height: $screen-height-mlg) {
          font-size: 0.7rem;
        }

        @media screen and (max-width: $screen-sm) {
          font-size: 0.8rem;
        }

        &::after {
          @include set-position(absolute, 0.25rem, auto, auto, 0);
          @include set-size(3px, 3px);
          content: "";
          background-color: #a0a0a0;
          border-radius: 50%;
        }
      }
    }
  }

  .swiper {
    .fa-angle-right {
      @include set-position(absolute, 40%, -5%, auto, auto);
      @include font-size-color(3rem, $mmc-red);
      transform: translateY(-50%);
      z-index: 2;
      cursor: pointer;

      @media screen and (max-width: $screen-es) {
        right: 0;
        top: 25%;
      }
    }
  }

  .slider-item.swiper-slide-active {
    z-index: 1;
  }

  .slider-flex {
    .slider-description {
      @include size-flex(60%);
      align-self: center;
      position: relative;

      @media screen and (max-width: $screen-es) {
        @include size-flex(100%);
      }

      .description {
        max-width: 75%;

        @media screen and (max-width: $screen-lg) {
          max-width: 100%;
        }
      }

      img {
        @include set-max-size(100%, 100%);
        cursor: pointer;
        margin: 0 auto;
        display: block;

        @media screen and (max-height: $screen-height-lg) {
          max-height: 20rem;
        }

        @media screen and (max-height: $screen-height-md) {
          max-height: 15rem;
        }

        @media screen and (max-width: $screen-md) {
          max-height: 100%;
        }
      }
    }

    .slider-interior {
      @include size-flex(25%);
      justify-self: flex-end;
      align-self: center;

      @media screen and (max-width: $screen-sm) {
        @include size-flex(30%);
      }

      @media screen and (max-width: $screen-es) {
        @include display-flex(flex, wrap);
        @include size-flex(100%);
      }

      div {
        @include set-background(no-repeat, center center, cover);
        @include size-flex(100%);
        @include image-hover();
        margin-bottom: 2.5rem;
        max-height: 20rem;
        min-height: 20rem;

        &:after {
          display: none;
        }

        @media screen and (max-height: $screen-height-lg) {
          max-height: 15rem;
          min-height: 15rem;
        }

        @media screen and (max-height: $screen-height-sm) {
          max-height: 12rem;
          min-height: 12rem;
        }

        @media screen and (max-width: $screen-md) {
          max-height: 12rem;
          min-height: 12rem;
        }

        @media screen and (max-width: $screen-es) {
          @include size-flex(100%);
          margin: 0 0 0.5rem;
        }

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }

  .under-slider {
    @include display-flex(flex, wrap);
    padding-top: calc(var(--page-offset) / 2);

    .slider-pagination {
      @include display-flex(flex, wrap);
      @include size-flex(55%);
      @include margin-padding(0, 0);
      list-style: none;
      border-bottom: 2px solid $slider-description;

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
      }

      li {
        @include font-size-color(1rem, $slider-description);
        position: relative;
        flex: 1 0 auto;
        align-self: flex-end;
        padding-bottom: 1rem;
        cursor: pointer;
        font-weight: 500;

        @media screen and (max-width: $screen-lg) {
          font-size: 0.9rem;
        }

        @media screen and (max-width: $screen-md) {
          font-size: 0.75rem;
          padding-bottom: calc(var(--page-offset) / 2);
        }

        @media screen and (max-width: $screen-md) {
          font-size: 0.65rem;
        }

        @media screen and (max-width: 360px) {
          font-size: 0.5rem;
        }

        &::after {
          @include set-position(absolute, auto, auto, -2px, 0);
          @include set-size(100%, 4px);
          content: "";
          background-color: transparent;
          transition: background-color 0.3s ease-in-out;
        }

        &.current-slide {
          color: $slider-header;

          &::after {
            background-color: $mmc-red;
          }
        }
      }
    }

    .buttons {
      @include display-flex(flex, wrap);
      @include size-flex(45%);
      justify-content: flex-end;

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
        padding-top: var(--page-offset);
      }

      .v-btn {
        margin-left: 2.8rem;

        &.mmc-red {
          &.text {
            @include size-flex(calc(35% - 2.8rem));
          }

          &.background {
            @include size-flex(calc(65% - 2.8rem));
          }
        }

        @media screen and (max-width: $screen-xl) {
          font-size: 1rem !important;
          margin-left: 1.4rem;

          &.mmc-red {
            &.text {
              @include size-flex(calc(35% - 1.4rem));
            }

            &.background {
              @include size-flex(calc(65% - 1.4rem));
            }
          }
        }

        @media screen and (max-width: $screen-md) {
          font-size: 0.9rem !important;
          margin-left: 0.9rem;

          &.mmc-red {
            &.text {
              @include size-flex(calc(35% - 0.9rem));
            }

            &.background {
              @include size-flex(calc(65% - 0.9rem));
            }
          }
        }

        @media screen and (max-width: $screen-sm) {
          &.mmc-red {
            &.text {
              @include size-flex(35%);
              margin-left: 0;
            }

            &.background {
              @include size-flex(calc(65% - 0.9rem));
            }
          }
        }
      }
    }
  }
}

.gallery-slider {
  overflow: hidden;

  .section-container {
    @include display-flex(flex, wrap);
    height: 100%;

    @media screen and (max-height: $screen-height-es) {
      height: auto;
    }

    @media screen and (max-width: $screen-sm) {
      height: auto;
    }

    .section-wrapper {
      @include size-flex(100%);
      padding: var(--page-offset) calc(2 * var(--page-offset)) 0;

      @media screen and (max-height: $screen-height-es) {
        padding-bottom: 10rem;
      }

      @media screen and (max-width: $screen-sm) {
        padding-bottom: 0;
      }

      .header-sub {
        color: $mmc-blue;

        &.second {
          color: $black;
        }
      }

      .header {
        color: $black;
      }

      .description {
        color: $slider-description;
        margin: 2rem 0;
      }
    }

    .gallery-nav {
      i {
        @include font-size-color(3rem, $mmc-red);
        @include set-position(
          absolute,
          calc(50% - 4.5rem),
          auto,
          auto,
          calc(1.1 * var(--page-offset))
        );
        z-index: 2;
        cursor: pointer;
        transform: translateY(-50%);

        &:last-of-type {
          left: auto;
          right: calc(1.25 * var(--page-offset));
        }

        @media screen and (max-width: $screen-sm) {
          top: 75%;
        }
      }
    }

    .swiper-container {
      overflow: visible;
    }

    .swiper {
      @include display-flex(flex, wrap);
      @include size-flex(100%);
      align-self: flex-end;

      .slider-item {
        height: 50vh;
        overflow: visible;

        @media screen and (max-height: $screen-height-es) {
          height: auto;
        }

        @media screen and (max-width: $screen-sm) {
          height: auto;
        }

        &.swiper-slide-active {
          .text {
            opacity: 1;
          }
        }

        .text {
          @include set-position(absolute, -9rem, auto, auto, calc(-34vw));
          transition: opacity 0.3s ease-in-out;
          opacity: 0;
          z-index: 1;
          width: 50vw;
          padding-left: calc(2 * var(--page-offset));

          @media screen and (max-width: $screen-lg) {
            width: 67vw;
          }

          @media screen and (max-width: $screen-md) {
            left: 0;
          }

          @media screen and (max-width: $screen-md) and (orientation: landscape) {
            left: calc(-34vw);
          }

          @media screen and (max-width: $screen-sm) {
            position: relative;
            left: 0;
            width: 100%;
            top: 0;
          }

          .header-sub {
            color: $black;
          }

          .description {
            color: $slider-description;
            margin: 2rem 0;

            @media screen and (max-width: $screen-lg) {
              margin: 1rem 0;
            }
          }
        }

        .background {
          @include set-size(100%, 100%);
          @include set-background(no-repeat, center center, cover);
          @include image-hover();

          @media screen and (max-width: $screen-md) and (orientation: landscape) {
            &::after {
              padding-top: 50%;
            }
          }

          @media screen and (max-width: $screen-sm) {
            &::after {
              padding-top: 50%;
            }
          }
        }
      }
    }
  }
}

.history {
  .section-container {
    @include display-flex(flex, wrap);
    @include set-background(no-repeat, center center, cover);
    background-image: url("../assets/images/home/car-history.jpg");
    padding: var(--page-offset);
    position: relative;
    margin: 0 var(--page-offset);
    min-height: 50vh;
    align-content: center;

    .header-sub {
      color: $mmc-blue;
    }

    @media screen and (max-height: $screen-height-lg) {
      .header {
        font-size: 2.15rem;
        margin: 1rem 0;
      }

      .description {
        font-size: 0.8rem !important;
        line-height: 1.2;
        margin-bottom: 1rem !important;
      }
    }

    @media screen and (max-width: $screen-lg) {
      .header {
        font-size: 2.15rem;
        margin: 1rem 0;
      }

      .description {
        font-size: 0.8rem !important;
        line-height: 1.2;
        margin-bottom: 1rem !important;
      }
    }

    @media screen and (max-height: 650px) {
      min-height: auto;
    }

    @media screen and (max-width: $screen-sm) {
      min-height: auto;
    }

    @media screen and (max-width: $screen-sm) {
      &::after {
        @include set-position(absolute, 0, 0, 0, 0);
        content: "";
        background-color: rgba($black, 0.5);
      }
    }

    .wrapper {
      @include z-index(relative, 1);
      width: 50%;

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }
    }

    .v-btn {
      text-align: center !important;

      @media screen and (max-width: $screen-xxl) {
        font-size: 1rem !important;
      }

      @media screen and (max-width: $screen-lg) {
        font-size: 0.8rem !important;
      }
    }
  }
}

footer {
  min-height: calc(50vh + (-1 * var(--page-offset)));
}
</style>
